import { useAudioLevel } from '@utils/hooks/useAudioLevel';
import './MicState.scss';
import { MicStateParams } from './MicState.type';

export default function MicState(props: MicStateParams) {
  const { micOn = false, stream, mode = 'small', outerLevel, ableOuterLevel } = props;
  const audioLevel = useAudioLevel(stream, false, !ableOuterLevel);
  return (
    <span className={`mic-state mic-state--${mode}`}>
      {micOn ? (
        <i className={`mic-state__mic-icon mic-state__mic-icon--level${ableOuterLevel ? outerLevel : audioLevel}`} />
      ) : (
        <i className="mic-state__mic-icon mic-state__mic-icon--off" />
      )}
    </span>
  );
}
